'use client'
import { LanguageProvider } from '@/lib/context/LanguageContext'
import LenisProvider from '@/components/layout/LenisProvider'
import { CartProvider } from '@/lib/cart/CartContext'
import CartDrawer from '@/components/cart/CartDrawer'
import type { Lang } from '@/lib/i18n'

export default function Providers({
  children,
  initialLang,
}: {
  children: React.ReactNode
  initialLang?: Lang
}) {
  return (
    <LanguageProvider initialLang={initialLang}>
      <CartProvider>
        <LenisProvider>{children}</LenisProvider>
        {/* Global slide-over cart — mounted once so open() works from any page. */}
        <CartDrawer />
      </CartProvider>
    </LanguageProvider>
  )
}
